export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref14823.9f021fa9.jpg";